// extracted by mini-css-extract-plugin
export default {"cards":"UserPrograms_cards__JM882"};